module.exports = __webpack_public_path__ + "../front/img/568_dobbelt_bøjlestang.eef1fd72.svg";